import {useLocation} from "react-router-dom";
import {Sport} from "../../../types/types";

export const useGetSelectedSport = () => {
    const { pathname } = useLocation();
    const getSelectedSport = (): Sport => {
        console.log("pathname: ", pathname)
        const sportPath = (pathname.split('/')[1] || 'nfl') as Sport;
        console.log("sportPath: ", sportPath)
        return sportPath as Sport;
    };
    return {getSelectedSport};
};

